import styles from "./Overlay.module.scss"

type Props = {
	opacity?: string
	color?: string
	zIndex?: number
	withLinear?: boolean
}

const Overlay = (props: Props) => {
	return (
		<>
			<div
				className={styles.overlay}
				style={{
					opacity: props.opacity ? props.opacity : "0.6",
					background: props?.color ?? "#0B1735",
					zIndex: props.zIndex ?? 10,
				}}
			/>
			{props.withLinear && (
				<div
					className={styles.overlay_linear}
					style={{
						background: "linear-gradient(#0B1735, #0B173500)",
						zIndex: props.zIndex ?? 10,
					}}
				/>
			)}
		</>
	)
}

export default Overlay
